import type { IButton } from '../../types/Button/button';
import { AnimatedSpinner } from './../../assets/Icons';
import styles from './button.module.scss';

export const Button = ({
  id,
  size = 'lg',
  leadingIcon,
  trailingIcon,
  color = 'primary',
  type = 'button',
  variant = 'contained',
  text,
  label,
  disabled = false,
  loading = false,
  onClickHandler,
  onBlurHandler
}: IButton) => {
  return (
    <button
      id={id}
      className={styles['btn']}
      data-btn-size={size}
      data-btn-color={color}
      data-btn-variant={variant}
      disabled={disabled || loading}
      onClick={onClickHandler}
      onBlur={onBlurHandler}
      type={type}
    >
      {leadingIcon}
      {label && <span className={styles['btn__label']}>{label}</span>}
      {text && <span>{text}</span>}
      {trailingIcon}
      {loading && AnimatedSpinner}
    </button>
  );
};
